import React, { useEffect, useState } from "react";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import Modal from "react-bootstrap/Modal";
import { Input } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import Apiurl from "../../Apiurl";
import Button from "react-bootstrap/Button";
import { Tabhelper } from "../../Helper/Tabhelper";
import Productoption from "../../Options/Productoption";
import Studentactiveoptions from "../../Options/Studentactiveoptions";

export default function Expense() {
  const [jsonList, setJsonList] = useState([]);
  //
  const apiurl = Apiurl();
  const usertype = window.localStorage.getItem("usertype");
  const { user } = useParams();

  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const productoption = Productoption();
  const studentoptions = Studentactiveoptions();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [expensetypeval, setexpensetypeval] = useState(null);

  const [clientid, setclientid] = useState(null);
  const [productdata, setproductdata] = useState([]);
  const [product, setproduct] = useState(null);
  const [period, setperiod] = useState(null);
  const [price, setprice] = useState(null);

  const handleSubmit = async () => {
    const formdata = {};
    const formdata1 = productdata.map((item, index) => ({
      productid: item.product,
      clientid: clientid.value,
      clientname: "",
      business_name: "",
      productname: "",
      totalamount: item.price,
      amountpaid: 0,
      remaining_amount: item.price,
      balance: null,
      period: item.period,
    }));
    console.log(formdata1);
    // try {
    //   const response = await axios.post(apiurl + "expense/", formdata);
    // } catch (error) {
    //   console.error(error);
    //   alert("Some Error occured\nTry again Later");
    // }
  };

  const handleexpensetypechange = (selectedOption) => {
    setclientid(selectedOption);
  };
  useEffect(() => {}, []);

  //
  const initialData = {
    name: "Purchase",
    link: "/client_purchase",
    active: "no",
  };
  // useEffect to add initial data to the JSON list
  useEffect(() => {
    Tabhelper(initialData, setJsonList);
  }, []);

  return (
    <Maincomponent tabname={"Purchase"}>
      <div className="component-sub">
        <div className="component-sub1">
          <div className="multistephead">
            <b>PURCHASE</b>
          </div>
          <br />
          <div className="Billcompmain">
            {/* <div className="Billcompmain1"></div> */}
            <div className="Billcompmain2">
              {" "}
              <div className="multistepcontainer1">
                <div className="multistepsubcontainer1">
                  <div className="multisteptable">
                    {/*  */}
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Client ID</div>
                      <div className="multisteptablecell2">
                        <Select
                          value={expensetypeval}
                          onChange={handleexpensetypechange}
                          options={studentoptions}
                          placeholder="Select Client ID"
                        />
                      </div>
                    </div>

                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Product</div>
                      <div className="multisteptablecell2">
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "80%" }}>
                            <Input
                              type="text"
                              value={
                                productdata.length == 0
                                  ? ""
                                  : productdata.length
                              }
                              readOnly
                              placeholder="Add Product"
                              className="textipbill"
                            />
                          </div>
                          &nbsp;
                          <Button
                            size="sm"
                            variant="warning"
                            onClick={handleShow}
                          >
                            &nbsp;+&nbsp;
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="multistepcontainerbtn">
                <button className="buttoncompnent1" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="Billcompmain"></div>
        </div>
        <Modal size="lg" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: "100%" }}>
              <div style={{ display: "flex" }}>
                <div style={{ width: "100%" }}>
                  <Select
                    value={product}
                    onChange={(selectedOption) => {
                      setproduct(selectedOption);
                    }}
                    options={productoption}
                    placeholder="Select Product"
                  />
                </div>
                &nbsp;&nbsp;
                <div style={{ width: "100%" }}>
                  <Select
                    value={period}
                    onChange={(selectedOption) => {
                      setperiod(selectedOption);
                    }}
                    options={[
                      { label: "1 Month", value: "1 Month" },
                      { label: "3 Months", value: "3 Months" },
                      { label: "6 Months", value: "6 Months" },
                      { label: "1 Years", value: "1 Years" },
                      { label: "2 Years", value: "2 Years" },
                      { label: "3 Years", value: "3 Years" },
                      { label: "4 Years", value: "4 Years" },
                      { label: "5 Years", value: "5 Years" },
                      { label: "6 Years", value: "6 Years" },
                    ]}
                    placeholder="Select Period"
                  />
                </div>
                &nbsp;&nbsp;
                <Input
                  type="text"
                  value={price}
                  placeholder="Price"
                  className="textipbill"
                  onChange={(e) => {
                    setprice(e.target.value);
                  }}
                />
                &nbsp;&nbsp;
                <Button
                  variant="primary"
                  onClick={() => {
                    const a = [
                      {
                        product: product.value,
                        price: price,
                        period: period.value,
                      },
                    ];
                    console.log(a);
                    setproductdata([...productdata, ...a]);

                    setproduct("");
                    setperiod("");
                    setprice("");
                    console.log(productdata);
                  }}
                >
                  Add
                </Button>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <table>
                <tr>
                  <td>Product</td>
                  <td>Price</td>
                  <td>Period</td>
                </tr>
                {productdata.map((item, index) => (
                  <tr key={index}>
                    <td>{item.product}</td>
                    <td>{item.price}</td>
                    <td>{item.period}</td>
                  </tr>
                ))}
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Maincomponent>
  );
}
